// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__MNKFH {
  display: flex;
  flex-direction: column;
  box-shadow: var(--modal-box-shadow);
  background: var(--tables-primary-row-surface-default);
}

.wrapper__Zsxe_ {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1501;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-height: 760px) {
  .wrapper__Zsxe_ {
    padding: 40px;
  }
}

.withoutBg__6Wahd {
  background: transparent;
}

.noScrollBody__dC_vc {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/ModalProvider/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,qDAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzEF;AA2EE;EAZF;IAaI,aAAA;EAxEF;AACF;;AA2EA;EACE,uBAAA;AAxEF;;AA2EA;EACE,gBAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--modal-box-shadow);\n  background: var(--tables-primary-row-surface-default);\n}\n\n.wrapper {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  z-index: 1501;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-height: 760px) {\n    padding: 40px;\n  }\n}\n\n.withoutBg {\n  background: transparent;\n}\n\n.noScrollBody {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__MNKFH`,
	"wrapper": `wrapper__Zsxe_`,
	"withoutBg": `withoutBg__6Wahd`,
	"noScrollBody": `noScrollBody__dC_vc`
};
module.exports = ___CSS_LOADER_EXPORT___;
